import type { Page } from "../content";
import { getPage } from "../content";
import { headings } from "../lib/headings";
import { DocLink } from "./DocLink";
import type { SiteState } from "../app/site-state";
export function TableOfContents(props: { site: SiteState; page: Page }) {
  const { site, page } = props;
  return (
    <aside class="toc" aria-label="On this page">
      <span class="toc-label">ON THIS PAGE</span>
      {page.slug === "ui"
        ? [
            ["ui-buttons", "Button gallery"],
            ["ui-badges", "Badge gallery"],
            ["ui-inputs", "Input states"],
            ["ui-cards", "Card gallery"],
            ["ui-composition", "Form & dialog"],
          ].map(([id, title]) => <a href={"#" + id}>{title}</a>)
        : null}
      {headings(page.body).map((heading) => (
        <a href={"#" + heading.id}>{heading.title}</a>
      ))}
      <div class="toc-note">
        <span>
          THE FRAMEWORK IS
          <br />
          THE FOUNDATION.
        </span>
        <p>
          Everything you see here
          <br />
          is built with Zyra.
        </p>
        <DocLink site={site} page={getPage("first-component")}>
          See how it works ↗
        </DocLink>
      </div>
    </aside>
  );
}
